// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CGMTab-module__font-s-10___Rzr9y {
  font-size: 10px !important;
}

.CGMTab-module__font-s-12___yy4d2 {
  font-size: 12px !important;
}

.CGMTab-module__font-s-13___c_mi5 {
  font-size: 13px !important;
}

.CGMTab-module__font-s-14___NWw2i {
  font-size: 14px !important;
}

.CGMTab-module__font-s-15___i2Hzo {
  font-size: 15px !important;
}

.CGMTab-module__font-s-16___XI7fd {
  font-size: 16px !important;
}

.CGMTab-module__font-s-18___RrGsk {
  font-size: 18px !important;
}

.CGMTab-module__font-s-20___lqgKX {
  font-size: 20px !important;
}

.CGMTab-module__font-s-22___uBi2Z {
  font-size: 22px !important;
}

.CGMTab-module__font-s-28___iNxeY {
  font-size: 28px !important;
}

.CGMTab-module__font-w-400___wKMoL {
  font-weight: 400 !important;
}

.CGMTab-module__font-w-500___TLIZD {
  font-weight: 500 !important;
}

.CGMTab-module__font-w-600___PsPLc {
  font-weight: 600 !important;
}

.CGMTab-module__font-w-700___ffx2N {
  font-weight: 700 !important;
}

.CGMTab-module__p-5___I9LWI {
  padding: 5px !important;
}

.CGMTab-module__p-12___v5o1r {
  padding: 12px !important;
}

.CGMTab-module__p-16___xeAWi {
  padding: 16px !important;
}

.CGMTab-module__p-30___VsRJE {
  padding: 30px !important;
}

.CGMTab-module__p-b-0___HToGa {
  padding-bottom: 0 !important;
}

.CGMTab-module__p-b-5___hMvqu {
  padding-bottom: 5px !important;
}

.CGMTab-module__p-b-10___MKkfw {
  padding-bottom: 10px !important;
}

.CGMTab-module__p-b-12___X8xWf {
  padding-bottom: 12px !important;
}

.CGMTab-module__p-b-16___BqjIp {
  padding-bottom: 16px !important;
}

.CGMTab-module__p-b-18___pjHfI {
  padding-bottom: 18px !important;
}

.CGMTab-module__p-b-20___hZd2q {
  padding-bottom: 20px !important;
}

.CGMTab-module__p-b-25___XIVrf {
  padding-bottom: 25px !important;
}

.CGMTab-module__p-b-30___V9vdm {
  padding-bottom: 30px !important;
}

.CGMTab-module__p-b-50___PYdb6 {
  padding-bottom: 50px !important;
}

.CGMTab-module__p-t-0___nGSoX {
  padding-top: 0 !important;
}

.CGMTab-module__p-t-12___ZUdx8 {
  padding-top: 12px !important;
}

.CGMTab-module__p-t-16___Y_8p_ {
  padding-top: 16px !important;
}

.CGMTab-module__p-t-18___QJ7jc {
  padding-top: 18px !important;
}

.CGMTab-module__p-t-20___oIFR7 {
  padding-top: 20px !important;
}

.CGMTab-module__p-t-30___lGqKe {
  padding-top: 30px !important;
}

.CGMTab-module__p-t-40___vu3UT {
  padding-top: 40px !important;
}

.CGMTab-module__p-t-50___fRpYa {
  padding-top: 50px !important;
}

.CGMTab-module__p-l-20___b4yUW {
  padding-left: 20px !important;
}

.CGMTab-module__p-l-30___oHZVv {
  padding-left: 30px !important;
}

.CGMTab-module__p-l-40___dYadK {
  padding-left: 40px !important;
}

.CGMTab-module__p-r-16___aoI0_ {
  padding-right: 16px !important;
}

.CGMTab-module__p-r-20___pXoJm {
  padding-right: 20px !important;
}

.CGMTab-module__p-r-30___hWKfJ {
  padding-right: 30px !important;
}

.CGMTab-module__p-r-50___RYwDt {
  padding-right: 50px !important;
}

.CGMTab-module__p-r-60___KxRHZ {
  padding-right: 60px !important;
}

.CGMTab-module__m-b-1___zSpJb {
  margin-bottom: 1px !important;
}

.CGMTab-module__m-b-2___Opgmr {
  margin-bottom: 2px !important;
}

.CGMTab-module__m-b-6___QWAR9 {
  margin-bottom: 6px !important;
}

.CGMTab-module__m-b-8___omY7J {
  margin-bottom: 8px !important;
}

.CGMTab-module__m-b-10___ThU7K {
  margin-bottom: 10px !important;
}

.CGMTab-module__m-b-14___isVkW {
  margin-bottom: 14px !important;
}

.CGMTab-module__m-b-16___j5qo9 {
  margin-bottom: 16px !important;
}

.CGMTab-module__m-b-20___IVP92 {
  margin-bottom: 20px !important;
}

.CGMTab-module__m-b-22___AOMgy {
  margin-bottom: 22px !important;
}

.CGMTab-module__m-b-24___GQnik {
  margin-bottom: 24px !important;
}

.CGMTab-module__m-b-30___Nxm4h {
  margin-bottom: 30px !important;
}

.CGMTab-module__m-b-32___VQPyy {
  margin-bottom: 32px !important;
}

.CGMTab-module__m-b-40___ug2mM {
  margin-bottom: 40px !important;
}

.CGMTab-module__m-t-2___N_Q6D {
  margin-top: 2px !important;
}

.CGMTab-module__m-t-3___te6mS {
  margin-top: 3px !important;
}

.CGMTab-module__m-t-4___LAvFL {
  margin-top: 4px !important;
}

.CGMTab-module__m-t-5___I_QWL {
  margin-top: 5px !important;
}

.CGMTab-module__m-t-8___ATIjs {
  margin-top: 8px !important;
}

.CGMTab-module__m-t-10___e6zrQ {
  margin-top: 10px !important;
}

.CGMTab-module__m-t-15___cj4KR {
  margin-top: 15px !important;
}

.CGMTab-module__m-t-16___GbAcb {
  margin-top: 16px !important;
}

.CGMTab-module__m-t-20___VAuqP {
  margin-top: 20px !important;
}

.CGMTab-module__m-t-22___a1DRl {
  margin-top: 22px !important;
}

.CGMTab-module__m-t-30___U4kXE {
  margin-top: 30px !important;
}

.CGMTab-module__m-t-32___xwn6H {
  margin-top: 32px !important;
}

.CGMTab-module__m-l-auto___z55n5 {
  margin-left: auto !important;
}

.CGMTab-module__m-l-4___uJfW_ {
  margin-left: 4px !important;
}

.CGMTab-module__m-l-5___zpRVa {
  margin-left: 5px !important;
}

.CGMTab-module__m-l-6___QjeEL {
  margin-left: 6px !important;
}

.CGMTab-module__m-l-8___Mtcp2 {
  margin-left: 8px !important;
}

.CGMTab-module__m-l-10___sHdIv {
  margin-left: 10px !important;
}

.CGMTab-module__m-l-16___nNPKM {
  margin-left: 16px !important;
}

.CGMTab-module__m-l-20___OmyVK {
  margin-left: 20px !important;
}

.CGMTab-module__m-l-24___M_zNN {
  margin-left: 24px !important;
}

.CGMTab-module__m-l-30___RMMGn {
  margin-left: 30px !important;
}

.CGMTab-module__m-l-35___Zik_b {
  margin-left: 35px !important;
}

.CGMTab-module__m-l-40___GyrgY {
  margin-left: 40px !important;
}

.CGMTab-module__m-r-8___hDORB {
  margin-right: 8px !important;
}

.CGMTab-module__m-r-10___wIuhA {
  margin-right: 10px !important;
}

.CGMTab-module__m-r-16___sRRRa {
  margin-right: 16px !important;
}

.CGMTab-module__m-r-20___IZcDH {
  margin-right: 20px !important;
}

.CGMTab-module__m-r-24___gUZzi {
  margin-right: 24px !important;
}

.CGMTab-module__m-r-30___lI8sr {
  margin-right: 30px !important;
}

.CGMTab-module__m-r-40___JC6TY {
  margin-right: 40px !important;
}

.CGMTab-module__border-r-3___b4Khq {
  border-radius: 3px !important;
}

.CGMTab-module__border-r-4___k6uVt {
  border-radius: 4px !important;
}

.CGMTab-module__border-r-6___rgu15 {
  border-radius: 6px !important;
}

.CGMTab-module__border-r-10___GAxrM {
  border-radius: 10px !important;
}

.CGMTab-module__border-r-12___QFuh8 {
  border-radius: 12px !important;
}

.CGMTab-module__border-r-16___KPNgQ {
  border-radius: 16px !important;
}

.CGMTab-module__border-r-50___S2vaG {
  border-radius: 50% !important;
}

.CGMTab-module__primary-border___CZnVg {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMTab-module__primary-border-b___z9Zbi {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMTab-module__primary-border-t___DluBL {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMTab-module__primary-border-l___ePNsU {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMTab-module__primary-border-r___yaL_r {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMTab-module__secondary-border___Ekxqa {
  border: 1px solid #637768;
}

.CGMTab-module__secondary-border-b___Me5aU {
  border-bottom: 1px solid #637768;
}

.CGMTab-module__secondary-border-t___vHnVm {
  border-top: 1px solid #637768;
}

.CGMTab-module__secondary-border-l___TNMcy {
  border-left: 1px solid #637768;
}

.CGMTab-module__secondary-border-r___aoIJm {
  border-right: 1px solid #637768;
}

.CGMTab-module__gap-0___WxeE6 {
  gap: 0 !important;
}

.CGMTab-module__gap-2___BHdTQ {
  gap: 2px !important;
}

.CGMTab-module__gap-4___ojpaX {
  gap: 4px !important;
}

.CGMTab-module__gap-5___XLD04 {
  gap: 5px !important;
}

.CGMTab-module__gap-6___Raz15 {
  gap: 6px !important;
}

.CGMTab-module__gap-8____tq2J {
  gap: 8px !important;
}

.CGMTab-module__gap-10___s238O {
  gap: 10px !important;
}

.CGMTab-module__gap-12___rrn40 {
  gap: 12px !important;
}

.CGMTab-module__gap-14___uXI4y {
  gap: 14px !important;
}

.CGMTab-module__gap-16___hxSN4 {
  gap: 16px !important;
}

.CGMTab-module__gap-18___aTyOD {
  gap: 18px !important;
}

.CGMTab-module__gap-20___CULTT {
  gap: 20px !important;
}

.CGMTab-module__gap-24___jIHQ0 {
  gap: 24px !important;
}

.CGMTab-module__gap-26___iiwNt {
  gap: 26px !important;
}

.CGMTab-module__gap-30___Ps4TW {
  gap: 30px !important;
}

.CGMTab-module__gap-32___IJB1T {
  gap: 32px !important;
}

.CGMTab-module__gap-40___xCZft {
  gap: 40px !important;
}

.CGMTab-module__gap-50___jSliT {
  gap: 50px !important;
}

.CGMTab-module__flex-1___lqEn0 {
  flex: 1;
}

.CGMTab-module__flex-none___JPjLd {
  flex: none !important;
}

.CGMTab-module__flex-column___XRgp5 {
  display: flex;
  flex-direction: column !important;
}

.CGMTab-module__flex-row___b093q {
  display: flex;
  flex-direction: row !important;
}

.CGMTab-module__vertically-centered___L4Uxd {
  display: flex;
  align-items: center !important;
}

.CGMTab-module__horizontally-centered___OUKVe {
  display: flex;
  justify-content: center !important;
}

.CGMTab-module__horizontally-end___bKYIU {
  display: flex;
  justify-content: end !important;
}

.CGMTab-module__vertically-start___vQCzK {
  display: flex;
  align-items: start !important;
}

.CGMTab-module__space-between___C4xsX {
  display: flex;
  justify-content: space-between !important;
}

.CGMTab-module__flex-wrap___DarFq {
  flex-wrap: wrap !important;
}

.CGMTab-module__height-100___ImPBg {
  height: 100%;
}

.CGMTab-module__width-50___iFg0f {
  width: 50% !important;
}

.CGMTab-module__width-100___Tv_jq {
  width: 100%;
}

.CGMTab-module__cursor-pointer___jzSiY {
  cursor: pointer;
}

.CGMTab-module__cursor-not-allowed___dbBYr {
  cursor: not-allowed !important;
}

.CGMTab-module__absolute-centered___bIkgs {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.CGMTab-module__absolute___n4d0r {
  position: absolute;
}

.CGMTab-module__relative___ciLad {
  position: relative;
}

.CGMTab-module__fixed___NfDI0 {
  position: fixed;
}

.CGMTab-module__visible___diSbq {
  opacity: 1;
}

.CGMTab-module__invisible____Mk0S {
  opacity: 0;
}

.CGMTab-module__col-90___CK4EI {
  width: 90% !important;
}

.CGMTab-module__col-auto___Ufuvk {
  width: auto !important;
}

.CGMTab-module__medical-tabs___yTokM {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.CGMTab-module__medical-table-new___rkF98 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CGMTab-module__medical-table-new___rkF98:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CGMTab-module__medical-table-new___rkF98::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CGMTab-module__medical-table-new___rkF98::-webkit-scrollbar-track {
  display: none;
}
.CGMTab-module__medical-table-new___rkF98.CGMTab-module__no-pagination___TJO52 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CGMTab-module__medical-table-new___rkF98.CGMTab-module__no-pagination___TJO52:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CGMTab-module__medical-table-new___rkF98.CGMTab-module__no-pagination___TJO52::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CGMTab-module__medical-table-new___rkF98.CGMTab-module__no-pagination___TJO52::-webkit-scrollbar-track {
  display: none;
}

.CGMTab-module__medical-table-empty___MInUZ {
  padding: 14px 40px !important;
}

.CGMTab-module__icon-btn___gk1z0 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.CGMTab-module__search-icon___dptgN {
  width: 24px;
  height: 24px;
  align-self: center;
}

.CGMTab-module__disable-select___QJ5Ct {
  user-select: none;
}

.CGMTab-module__break-word___XYWIU {
  word-break: break-word;
}

.CGMTab-module__popup-clear-btn___NAKDL {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.CGMTab-module__scroll-m-b-20___jHsUI {
  scroll-margin-bottom: 20px;
}

.CGMTab-module__scroll___gvOVH {
  height: calc(100vh - var(--top-navigation) - var(--patient-details-header) - var(--patient-details-footer) - 215px);
  overflow-y: scroll;
  overflow-x: hidden;
}
.CGMTab-module__scroll___gvOVH:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CGMTab-module__scroll___gvOVH::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CGMTab-module__scroll___gvOVH::-webkit-scrollbar-track {
  display: none;
}
.CGMTab-module__scroll___gvOVH .CGMTab-module__chartWrapper___VX7tD {
  padding-left: 20px;
  width: calc(100% - 40px);
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/Biometrics/tabs/CGMTab/CGMTab.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;ECQE,mHDNE;ECOF,kBAAA;EACA,kBAAA;ADupBF;ACrpBE;EACE,oCAAA;EACA,mBAAA;ADupBJ;ACppBE;EACE,UAAA;EACA,6BAAA;ADspBJ;ACnpBE;EACE,aAAA;ADqpBJ;AApqBE;EACE,kBAAA;EACA,wBAAA;AAsqBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.scroll {\n  @include verticalScroll(\n    calc(\n      100vh - var(--top-navigation) - var(--patient-details-header) - var(--patient-details-footer) -\n        215px\n    )\n  );\n\n  .chartWrapper {\n    padding-left: 20px;\n    width: calc(100% - 40px);\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `CGMTab-module__font-s-10___Rzr9y`,
	"fontS12": `CGMTab-module__font-s-12___yy4d2`,
	"fontS13": `CGMTab-module__font-s-13___c_mi5`,
	"fontS14": `CGMTab-module__font-s-14___NWw2i`,
	"fontS15": `CGMTab-module__font-s-15___i2Hzo`,
	"fontS16": `CGMTab-module__font-s-16___XI7fd`,
	"fontS18": `CGMTab-module__font-s-18___RrGsk`,
	"fontS20": `CGMTab-module__font-s-20___lqgKX`,
	"fontS22": `CGMTab-module__font-s-22___uBi2Z`,
	"fontS28": `CGMTab-module__font-s-28___iNxeY`,
	"fontW400": `CGMTab-module__font-w-400___wKMoL`,
	"fontW500": `CGMTab-module__font-w-500___TLIZD`,
	"fontW600": `CGMTab-module__font-w-600___PsPLc`,
	"fontW700": `CGMTab-module__font-w-700___ffx2N`,
	"p5": `CGMTab-module__p-5___I9LWI`,
	"p12": `CGMTab-module__p-12___v5o1r`,
	"p16": `CGMTab-module__p-16___xeAWi`,
	"p30": `CGMTab-module__p-30___VsRJE`,
	"pB0": `CGMTab-module__p-b-0___HToGa`,
	"pB5": `CGMTab-module__p-b-5___hMvqu`,
	"pB10": `CGMTab-module__p-b-10___MKkfw`,
	"pB12": `CGMTab-module__p-b-12___X8xWf`,
	"pB16": `CGMTab-module__p-b-16___BqjIp`,
	"pB18": `CGMTab-module__p-b-18___pjHfI`,
	"pB20": `CGMTab-module__p-b-20___hZd2q`,
	"pB25": `CGMTab-module__p-b-25___XIVrf`,
	"pB30": `CGMTab-module__p-b-30___V9vdm`,
	"pB50": `CGMTab-module__p-b-50___PYdb6`,
	"pT0": `CGMTab-module__p-t-0___nGSoX`,
	"pT12": `CGMTab-module__p-t-12___ZUdx8`,
	"pT16": `CGMTab-module__p-t-16___Y_8p_`,
	"pT18": `CGMTab-module__p-t-18___QJ7jc`,
	"pT20": `CGMTab-module__p-t-20___oIFR7`,
	"pT30": `CGMTab-module__p-t-30___lGqKe`,
	"pT40": `CGMTab-module__p-t-40___vu3UT`,
	"pT50": `CGMTab-module__p-t-50___fRpYa`,
	"pL20": `CGMTab-module__p-l-20___b4yUW`,
	"pL30": `CGMTab-module__p-l-30___oHZVv`,
	"pL40": `CGMTab-module__p-l-40___dYadK`,
	"pR16": `CGMTab-module__p-r-16___aoI0_`,
	"pR20": `CGMTab-module__p-r-20___pXoJm`,
	"pR30": `CGMTab-module__p-r-30___hWKfJ`,
	"pR50": `CGMTab-module__p-r-50___RYwDt`,
	"pR60": `CGMTab-module__p-r-60___KxRHZ`,
	"mB1": `CGMTab-module__m-b-1___zSpJb`,
	"mB2": `CGMTab-module__m-b-2___Opgmr`,
	"mB6": `CGMTab-module__m-b-6___QWAR9`,
	"mB8": `CGMTab-module__m-b-8___omY7J`,
	"mB10": `CGMTab-module__m-b-10___ThU7K`,
	"mB14": `CGMTab-module__m-b-14___isVkW`,
	"mB16": `CGMTab-module__m-b-16___j5qo9`,
	"mB20": `CGMTab-module__m-b-20___IVP92`,
	"mB22": `CGMTab-module__m-b-22___AOMgy`,
	"mB24": `CGMTab-module__m-b-24___GQnik`,
	"mB30": `CGMTab-module__m-b-30___Nxm4h`,
	"mB32": `CGMTab-module__m-b-32___VQPyy`,
	"mB40": `CGMTab-module__m-b-40___ug2mM`,
	"mT2": `CGMTab-module__m-t-2___N_Q6D`,
	"mT3": `CGMTab-module__m-t-3___te6mS`,
	"mT4": `CGMTab-module__m-t-4___LAvFL`,
	"mT5": `CGMTab-module__m-t-5___I_QWL`,
	"mT8": `CGMTab-module__m-t-8___ATIjs`,
	"mT10": `CGMTab-module__m-t-10___e6zrQ`,
	"mT15": `CGMTab-module__m-t-15___cj4KR`,
	"mT16": `CGMTab-module__m-t-16___GbAcb`,
	"mT20": `CGMTab-module__m-t-20___VAuqP`,
	"mT22": `CGMTab-module__m-t-22___a1DRl`,
	"mT30": `CGMTab-module__m-t-30___U4kXE`,
	"mT32": `CGMTab-module__m-t-32___xwn6H`,
	"mLAuto": `CGMTab-module__m-l-auto___z55n5`,
	"mL4": `CGMTab-module__m-l-4___uJfW_`,
	"mL5": `CGMTab-module__m-l-5___zpRVa`,
	"mL6": `CGMTab-module__m-l-6___QjeEL`,
	"mL8": `CGMTab-module__m-l-8___Mtcp2`,
	"mL10": `CGMTab-module__m-l-10___sHdIv`,
	"mL16": `CGMTab-module__m-l-16___nNPKM`,
	"mL20": `CGMTab-module__m-l-20___OmyVK`,
	"mL24": `CGMTab-module__m-l-24___M_zNN`,
	"mL30": `CGMTab-module__m-l-30___RMMGn`,
	"mL35": `CGMTab-module__m-l-35___Zik_b`,
	"mL40": `CGMTab-module__m-l-40___GyrgY`,
	"mR8": `CGMTab-module__m-r-8___hDORB`,
	"mR10": `CGMTab-module__m-r-10___wIuhA`,
	"mR16": `CGMTab-module__m-r-16___sRRRa`,
	"mR20": `CGMTab-module__m-r-20___IZcDH`,
	"mR24": `CGMTab-module__m-r-24___gUZzi`,
	"mR30": `CGMTab-module__m-r-30___lI8sr`,
	"mR40": `CGMTab-module__m-r-40___JC6TY`,
	"borderR3": `CGMTab-module__border-r-3___b4Khq`,
	"borderR4": `CGMTab-module__border-r-4___k6uVt`,
	"borderR6": `CGMTab-module__border-r-6___rgu15`,
	"borderR10": `CGMTab-module__border-r-10___GAxrM`,
	"borderR12": `CGMTab-module__border-r-12___QFuh8`,
	"borderR16": `CGMTab-module__border-r-16___KPNgQ`,
	"borderR50": `CGMTab-module__border-r-50___S2vaG`,
	"primaryBorder": `CGMTab-module__primary-border___CZnVg`,
	"primaryBorderB": `CGMTab-module__primary-border-b___z9Zbi`,
	"primaryBorderT": `CGMTab-module__primary-border-t___DluBL`,
	"primaryBorderL": `CGMTab-module__primary-border-l___ePNsU`,
	"primaryBorderR": `CGMTab-module__primary-border-r___yaL_r`,
	"secondaryBorder": `CGMTab-module__secondary-border___Ekxqa`,
	"secondaryBorderB": `CGMTab-module__secondary-border-b___Me5aU`,
	"secondaryBorderT": `CGMTab-module__secondary-border-t___vHnVm`,
	"secondaryBorderL": `CGMTab-module__secondary-border-l___TNMcy`,
	"secondaryBorderR": `CGMTab-module__secondary-border-r___aoIJm`,
	"gap0": `CGMTab-module__gap-0___WxeE6`,
	"gap2": `CGMTab-module__gap-2___BHdTQ`,
	"gap4": `CGMTab-module__gap-4___ojpaX`,
	"gap5": `CGMTab-module__gap-5___XLD04`,
	"gap6": `CGMTab-module__gap-6___Raz15`,
	"gap8": `CGMTab-module__gap-8____tq2J`,
	"gap10": `CGMTab-module__gap-10___s238O`,
	"gap12": `CGMTab-module__gap-12___rrn40`,
	"gap14": `CGMTab-module__gap-14___uXI4y`,
	"gap16": `CGMTab-module__gap-16___hxSN4`,
	"gap18": `CGMTab-module__gap-18___aTyOD`,
	"gap20": `CGMTab-module__gap-20___CULTT`,
	"gap24": `CGMTab-module__gap-24___jIHQ0`,
	"gap26": `CGMTab-module__gap-26___iiwNt`,
	"gap30": `CGMTab-module__gap-30___Ps4TW`,
	"gap32": `CGMTab-module__gap-32___IJB1T`,
	"gap40": `CGMTab-module__gap-40___xCZft`,
	"gap50": `CGMTab-module__gap-50___jSliT`,
	"flex1": `CGMTab-module__flex-1___lqEn0`,
	"flexNone": `CGMTab-module__flex-none___JPjLd`,
	"flexColumn": `CGMTab-module__flex-column___XRgp5`,
	"flexRow": `CGMTab-module__flex-row___b093q`,
	"verticallyCentered": `CGMTab-module__vertically-centered___L4Uxd`,
	"horizontallyCentered": `CGMTab-module__horizontally-centered___OUKVe`,
	"horizontallyEnd": `CGMTab-module__horizontally-end___bKYIU`,
	"verticallyStart": `CGMTab-module__vertically-start___vQCzK`,
	"spaceBetween": `CGMTab-module__space-between___C4xsX`,
	"flexWrap": `CGMTab-module__flex-wrap___DarFq`,
	"height100": `CGMTab-module__height-100___ImPBg`,
	"width50": `CGMTab-module__width-50___iFg0f`,
	"width100": `CGMTab-module__width-100___Tv_jq`,
	"cursorPointer": `CGMTab-module__cursor-pointer___jzSiY`,
	"cursorNotAllowed": `CGMTab-module__cursor-not-allowed___dbBYr`,
	"absoluteCentered": `CGMTab-module__absolute-centered___bIkgs`,
	"absolute": `CGMTab-module__absolute___n4d0r`,
	"relative": `CGMTab-module__relative___ciLad`,
	"fixed": `CGMTab-module__fixed___NfDI0`,
	"visible": `CGMTab-module__visible___diSbq`,
	"invisible": `CGMTab-module__invisible____Mk0S`,
	"col90": `CGMTab-module__col-90___CK4EI`,
	"colAuto": `CGMTab-module__col-auto___Ufuvk`,
	"medicalTabs": `CGMTab-module__medical-tabs___yTokM`,
	"medicalTableNew": `CGMTab-module__medical-table-new___rkF98`,
	"noPagination": `CGMTab-module__no-pagination___TJO52`,
	"medicalTableEmpty": `CGMTab-module__medical-table-empty___MInUZ`,
	"iconBtn": `CGMTab-module__icon-btn___gk1z0`,
	"searchIcon": `CGMTab-module__search-icon___dptgN`,
	"disableSelect": `CGMTab-module__disable-select___QJ5Ct`,
	"breakWord": `CGMTab-module__break-word___XYWIU`,
	"popupClearBtn": `CGMTab-module__popup-clear-btn___NAKDL`,
	"scrollMB20": `CGMTab-module__scroll-m-b-20___jHsUI`,
	"scroll": `CGMTab-module__scroll___gvOVH`,
	"chartWrapper": `CGMTab-module__chartWrapper___VX7tD`
};
module.exports = ___CSS_LOADER_EXPORT___;
